import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { APIError } from '../../types/api/api';
import { ChangeResponsableDTO } from '../../types/actions/actions';
import { User } from '../../types/users/users';

export type ChangeResponsableState = {
  loading: boolean;
  errors: APIError | null;
  active: boolean;
  user: User | null;
};

const initialState: ChangeResponsableState = {
  loading: false,
  errors: null,
  active: false,
  user: null,
};

const changeResponsableSlice = createSlice({
  name: 'changeResponsable',
  initialState,
  reducers: {
    showChangeResponsable(state, action: PayloadAction<User>) {
      state.user = action.payload;
      state.active = true;
    },
    hideChangeResponsable() {
      return { ...initialState };
    },
    changeResponsable(state, _action: PayloadAction<ChangeResponsableDTO>) {
      state.loading = true;
      state.errors = null;
    },
    changeResponsableOk(state) {
      state.loading = false;
      state.errors = null;
    },
    changeResponsableKo(state, action: PayloadAction<APIError>) {
      state.loading = false;
      state.errors = action.payload;
    },
  },
});

export const {
  showChangeResponsable,
  hideChangeResponsable,
  changeResponsable,
  changeResponsableOk,
  changeResponsableKo,
} = changeResponsableSlice.actions;

export default changeResponsableSlice;
